// Origin of the embed host (https://embed.famewall.io in production). Set once
// by the bootstrap from the <script src> tag, then used to:
//  - call /api/seo-embed
//  - resolve root-relative assets (/DarkFamewallLogo.svg, /appstore.svg, ...)
//    that the real card components reference via next/image.
let embedOrigin = '';

export function setEmbedOrigin(value) {
  embedOrigin = value || '';
}

export function getEmbedOrigin() {
  if (embedOrigin) {
    return embedOrigin;
  }

  return typeof window !== 'undefined' ? window.location.origin : '';
}
